"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);

const NO_NAMES = []

// Names of the org's other patients at this patient's phone, loaded each
// time `isActive` turns on (the mark-opted-out dialog opening). It's a
// warning only: while loading, or if the lookup fails, it's empty, and the
// dialog never waits on it.
 const usePatientsSharingSMSPhone = (
  orgKey,
  patientKey,
  isActive,
) => {
  const [loaded, setLoaded] = _react.useState(null)
  const key = `${orgKey}|${patientKey}`

  _react.useEffect.call(void 0, () => {
    if (!isActive) return undefined
    let isCurrent = true
    setLoaded(null)
    _actions2.default.getPatientsSharingSMSPhone({ OrgKey: orgKey, PatientKey: patientKey })
      .then(({ Patients }) => {
        if (isCurrent) setLoaded({ key, names: (Patients || []).map(p => p.Name) })
      })
      .catch(() => undefined)
    return () => { isCurrent = false }
  }, [isActive, key, orgKey, patientKey])

  return isActive && _optionalChain([loaded, 'optionalAccess', _ => _.key]) === key ? loaded.names : NO_NAMES
}; exports.usePatientsSharingSMSPhone = usePatientsSharingSMSPhone

exports. default = exports.usePatientsSharingSMSPhone
